<template>
    <main>
        <section class="slogan">
            <div class="container1366 padding120 hero-wrapper">
                <div class="hero-text-wrapper hero-text-wrapper1">
                    <div class="hero-title">{{ $t('lp-collections05') }}<div>{{ $t('lp-collections06') }}</div></div>
                    <div class="hero-text">{{ $t('lp-collections003') }}</div>
                    <nuxt-link :to="localePath('/collections')" class="hero-btn ga4-reg-btn">{{ $t('lp-collections04') }}</nuxt-link>
                </div>
                <div class="hero-text-wrapper"></div>
            </div>
            <div class="container1366 padding120 slogan-bullets">
                <div class="why-vindome-wrapper">
                    <v-row>
                        <v-col class="why-vindome-col">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M36.1626 8.00006C33.4431 8.01985 30.8422 9.0553 28.9268 10.8807C27.0114 12.706 25.9369 15.1733 25.9376 17.7446C25.9384 19.6012 26.5003 21.4189 27.5572 22.9837C28.614 24.5485 30.1217 25.7952 31.9028 26.577V18.9073C31.9028 16.6504 33.8707 14.7898 36.2577 14.7898C38.6448 14.7898 40.6127 16.6504 40.6127 18.9073V26.5641C42.3854 25.7786 43.8846 24.5319 44.935 22.97C45.9854 21.408 46.5435 19.5955 46.5439 17.7446C46.5442 16.4648 46.2778 15.1976 45.76 14.0152C45.2421 12.8328 44.483 11.7585 43.5259 10.8535C42.5687 9.94863 41.4324 9.23086 40.1819 8.74125C38.9313 8.25164 37.5909 7.99978 36.2374 8.00006C36.2125 7.99998 36.1875 7.99998 36.1626 8.00006H36.1626ZM36.2373 16.1002C34.6011 16.1002 33.2887 17.3474 33.2887 18.8944V28.9023V37.9916C33.2887 38.0051 33.2953 38.0166 33.2955 38.0302L33.3023 44.5501C33.3008 45.1739 32.7663 45.6792 32.1066 45.6806C31.4441 45.6828 30.9055 45.1764 30.904 44.5501V44.5435V38.7944C30.904 37.2474 29.5848 36.0002 27.9486 36.0002C26.3124 36.0002 25 37.2474 25 38.7944V47.3763C25 47.9106 25.1964 48.385 25.4688 48.8087L33.9545 59.6003C34.7373 60.9198 36.1739 61.8485 37.8883 61.8486H52.4275C54.9523 61.848 56.9993 59.9126 56.9999 57.5255V36.5911C57 36.576 57 36.5612 56.9999 36.5462C56.9748 35.2473 55.8533 34.2071 54.4793 34.208C53.733 34.2106 53.0264 34.5258 52.5498 35.0688C52.4708 35.1844 52.3353 35.2545 52.1897 35.2551C51.9539 35.2571 51.7602 35.0797 51.7549 34.8568H51.7479C51.7601 34.763 51.7671 34.6687 51.7685 34.5742C51.7709 33.0964 50.5052 31.8968 48.9421 31.8955C47.9628 31.8953 47.053 32.374 46.5371 33.161C46.5348 33.1653 46.5325 33.1696 46.5301 33.1738C46.4643 33.2736 46.3488 33.3343 46.2244 33.3344C46.0256 33.3342 45.8645 33.1819 45.8643 32.994C45.8658 32.981 45.8681 32.9682 45.8712 32.9554H45.8643C45.8768 32.8574 45.8838 32.7587 45.8848 32.66C45.8835 31.1847 44.6189 29.989 43.0585 29.9878C42.1216 29.9895 41.2464 30.4297 40.7214 31.1633C40.5822 31.4183 40.3047 31.5792 40.0012 31.5808C39.5509 31.5808 39.1859 31.2357 39.1859 30.81C39.184 30.7649 39.1862 30.7198 39.1929 30.6751V18.8944C39.1929 17.3474 37.8737 16.1002 36.2375 16.1002H36.2373ZM34.1312 64.1869C33.1092 64.1869 32.2832 64.9678 32.2832 65.9341V71.2528C32.2832 72.2191 33.1092 73 34.1312 73H54.921C55.943 73 56.7621 72.2191 56.7621 71.2528V65.9341C56.7621 64.9678 55.943 64.1869 54.921 64.1869H34.1312Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('home2') }}</div>
                                <div class="card-text">{{ $t('home3') }}</div>
                            </div>
                        </v-col>
                        <v-col class="why-vindome-col why-vindome-col-2">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M40 8L14 19.6364V37.0909C14 53.2364 25.0933 68.3345 40 72C54.9067 68.3345 66 53.2364 66 37.0909V19.6364L40 8ZM34.2222 54.5455L22.6667 42.9091L26.74 38.8073L34.2222 46.3127L53.26 27.1418L57.3333 31.2727L34.2222 54.5455Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('home4') }}</div>
                                <div class="card-text">{{ $t('home5') }}</div>
                            </div>
                        </v-col>
                        <v-col class="why-vindome-col">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9989 8.00049C38.116 8.00064 36.4322 9.03315 35.0207 10.6092C34.6649 10.5304 34.3014 10.4906 33.9366 10.4906C33.9121 10.4904 33.8875 10.4904 33.863 10.4906C31.1746 10.5306 29.0165 12.6769 29.0163 15.3109C29.0171 16.716 29.6436 18.0509 30.7318 18.9662C30.3624 20.1011 29.9958 21.2405 29.6898 22.508C28.0023 22.0126 26.3802 21.6212 24.8484 21.3377C21.7912 20.7718 19.0828 20.629 16.8337 21.0026C14.5847 21.3762 12.705 22.3156 11.7134 23.9979V24.0031C10.722 25.6856 10.8296 27.7492 11.6239 29.8442C12.4182 31.9392 13.8945 34.1633 15.9233 36.4741C16.9405 37.6327 18.0976 38.8154 19.3808 40.0005C18.0976 41.1856 16.9405 42.3683 15.9233 43.5268C13.8945 45.8377 12.4182 48.0618 11.6239 50.1568C10.8296 52.2517 10.722 54.3154 11.7134 55.9979C12.705 57.6802 14.5847 58.6248 16.8337 58.9984C17.1791 59.0557 17.5564 59.0784 17.9231 59.1118C18.6314 61.0161 20.4799 62.2831 22.5487 62.2824C25.0393 62.2809 27.1361 60.4569 27.4323 58.0343C28.1881 57.8478 28.9031 57.719 29.6898 57.4878C30.0959 59.1693 30.5634 60.7418 31.0791 62.1845C32.1075 65.0612 33.3344 67.4281 34.7891 69.1495C36.2439 70.8709 38.016 72.0003 39.9989 72.0005C41.9819 72.0003 43.754 70.8709 45.2088 69.1495C46.6635 67.4281 47.8904 65.0612 48.9188 62.1845C49.4345 60.7418 49.902 59.1693 50.308 57.4878C51.9961 57.9837 53.6174 58.3796 55.1495 58.6633C58.2072 59.2294 60.9094 59.3719 63.1589 58.9984C65.4084 58.6249 67.2927 57.6805 68.2845 55.9979C69.276 54.3152 69.1685 52.2468 68.374 50.1516C68.2229 49.7534 68.0263 49.3473 67.8267 48.9401C68.3946 48.1355 68.6992 47.1807 68.7002 46.2025C68.6996 43.5405 66.4971 41.3827 63.7799 41.3822C63.7553 41.382 63.7307 41.382 63.7062 41.3822C63.1997 41.389 62.6974 41.4725 62.2169 41.6296C61.6774 41.0832 61.207 40.545 60.6119 39.9953C61.894 38.8114 63.0526 37.6373 64.0693 36.4793C66.0986 34.1682 67.5794 31.9394 68.374 29.8442C69.1685 27.749 69.276 25.6858 68.2845 24.0031V23.9979C67.2927 22.3154 65.4084 21.3761 63.1589 21.0026C60.9094 20.6291 58.2072 20.7715 55.1495 21.3377C53.6174 21.6214 51.9961 22.0173 50.308 22.5131C49.9019 20.8317 49.4345 19.2594 48.9188 17.8165C47.8904 14.9392 46.6637 12.5681 45.2088 10.8463C43.7539 9.12456 41.9822 8.00064 39.9989 8.00049ZM39.9989 10.3462C41.0587 10.3463 42.1851 10.948 43.3669 12.3465C44.5487 13.7451 45.6956 15.8881 46.6612 18.5898C47.1683 20.0086 47.6237 21.5946 48.0242 23.2916C45.4434 24.1585 42.771 25.1921 39.9989 26.4932C37.2284 25.1931 34.5584 24.1527 31.979 23.2865C32.2522 22.1311 32.5575 21.0527 32.8789 20.0179C33.2262 20.093 33.5809 20.1311 33.9366 20.1313C36.6538 20.1307 38.8564 17.9729 38.857 15.3109C38.8548 13.9458 38.2619 12.6457 37.2256 11.733C38.1905 10.7927 39.1194 10.3463 39.9989 10.3462ZM18.7229 23.1679C20.3229 23.092 22.2481 23.2437 24.4011 23.6422C25.9085 23.9212 27.5368 24.3351 29.2373 24.8434C28.7146 27.4637 28.2989 30.2478 28.0638 33.2468C25.5273 34.9484 23.2745 36.6974 21.2173 38.4539C19.9166 37.2648 18.74 36.0884 17.7389 34.9481C15.8338 32.7783 14.5109 30.7313 13.8657 29.0297C13.2206 27.328 13.2518 26.0724 13.7815 25.1734C14.3114 24.2744 15.4069 23.6208 17.2337 23.3174C17.6904 23.2415 18.1896 23.1932 18.7229 23.1679ZM59.5647 23.1679C60.7692 23.1152 61.8454 23.1657 62.759 23.3174C64.5861 23.6208 65.6811 24.2743 66.2111 25.1734C66.7409 26.0725 66.7723 27.3277 66.1269 29.0297C65.4815 30.7316 64.1593 32.778 62.2538 34.9481C61.2537 36.087 60.0791 37.2608 58.7806 38.4487C56.7245 36.6928 54.4693 34.9479 51.9341 33.2468C51.6982 30.248 51.2842 27.4636 50.7606 24.8434C52.4594 24.3353 54.0852 23.9211 55.5915 23.6422C57.0271 23.3764 58.3601 23.2206 59.5647 23.1679ZM31.5264 25.6219C33.3801 26.2561 35.2894 27.0083 37.2677 27.88C36.143 28.4559 35.0228 28.9968 33.8893 29.638C32.7556 30.2792 31.7192 30.9615 30.6476 31.628C30.8663 29.5118 31.1598 27.5131 31.5264 25.6219ZM48.4715 25.6219C48.8371 27.5117 49.1323 29.5084 49.3503 31.6229C48.2775 30.9556 47.2385 30.2748 46.1034 29.6328C44.9716 28.9927 43.8531 28.4549 42.7301 27.88C44.7081 27.008 46.6182 26.2564 48.4715 25.6219ZM39.9989 29.1121C41.6218 29.8994 43.2609 30.7321 44.9088 31.6641C46.5574 32.5965 48.1161 33.5676 49.6239 34.5512C49.7393 36.3243 49.8187 38.1332 49.8186 40.0005C49.8186 41.8675 49.7394 43.6767 49.6239 45.4498C48.1161 46.4334 46.5574 47.4045 44.9088 48.3369C43.2609 49.2689 41.6218 50.1015 39.9989 50.8888C38.3741 50.1003 36.734 49.2652 35.0838 48.3317C33.4355 47.3994 31.8765 46.4278 30.3687 45.4447C30.2531 43.6731 30.174 41.8657 30.174 40.0005C30.1739 38.135 30.2531 36.3279 30.3687 34.5563C31.8765 33.5731 33.4355 32.6016 35.0838 31.6693C36.734 30.7358 38.3741 29.9007 39.9989 29.1121ZM39.7674 33.109C35.9432 33.109 32.8171 36.1716 32.8171 39.918C32.8171 43.6644 35.9432 46.727 39.7674 46.727C43.5916 46.727 46.7177 43.6644 46.7177 39.918C46.7177 36.1716 43.5916 33.109 39.7674 33.109ZM27.9217 36.2525C27.8684 37.4958 27.7848 38.7168 27.7848 40.0005C27.7849 41.284 27.8682 42.5052 27.9217 43.7485C26.1591 42.5048 24.5382 41.2573 23.0487 40.0005C24.5382 38.7437 26.1591 37.4962 27.9217 36.2525H27.9217ZM52.0762 36.2525C53.8369 37.4958 55.4559 38.7441 56.944 40.0005C55.4559 41.2569 53.8369 42.5052 52.0762 43.7485C52.1297 42.5052 52.213 41.284 52.213 40.0005C52.2131 38.7168 52.1296 37.4958 52.0762 36.2525ZM21.2173 41.5471C23.2745 43.3036 25.5273 45.0526 28.0638 46.7542C28.2997 49.753 28.7138 52.5372 29.2373 55.1576C28.5218 55.3714 27.8291 55.5576 27.1428 55.735C26.4126 53.8717 24.586 52.6418 22.5487 52.6417C22.5224 52.6415 22.4961 52.6415 22.4698 52.6417C20.0693 52.6778 18.0458 54.4054 17.681 56.73C17.5366 56.7117 17.3709 56.7064 17.2337 56.6836C15.4069 56.3802 14.3114 55.7266 13.7815 54.8276C13.2518 53.9286 13.2206 52.673 13.8657 50.9713C14.5109 49.2697 15.8338 47.2227 17.7389 45.0529C18.74 43.9126 19.9166 42.7362 21.2173 41.5471ZM58.7753 41.5471C59.2733 42.0026 59.7374 42.4528 60.1962 42.903C59.3385 43.7963 58.8605 44.9762 58.8595 46.2025C58.8601 48.8645 61.0627 51.0223 63.7799 51.0229C64.5237 51.0224 65.2578 50.8567 65.9269 50.5383C65.9882 50.6809 66.0745 50.8331 66.1269 50.9713C66.7723 52.6733 66.7409 53.9284 66.2111 54.8276C65.6812 55.7267 64.5861 56.3802 62.759 56.6836C60.9318 56.987 58.4627 56.8904 55.5915 56.3588C54.0852 56.0799 52.4594 55.6657 50.7606 55.1576C51.2844 52.5357 51.6982 49.7498 51.9341 46.749C54.4681 45.0495 56.72 43.3013 58.7753 41.5471H58.7753ZM30.6476 48.373C31.7192 49.0395 32.7556 49.7218 33.8893 50.363C35.0228 51.0042 36.143 51.5451 37.2677 52.121C35.2894 52.9927 33.3801 53.7449 31.5264 54.3791C31.1598 52.4877 30.8663 50.4892 30.6476 48.373ZM49.3503 48.373C49.1322 50.4894 48.8374 52.4876 48.4715 54.3791C46.6168 53.7441 44.7044 52.9938 42.7249 52.121C43.8499 51.5449 44.9695 51.0043 46.1034 50.363C47.2385 49.721 48.2775 49.0401 49.3503 48.373ZM39.9884 53.5027C42.7643 54.806 45.44 55.8414 48.0242 56.7094C47.6237 58.4064 47.1683 59.9926 46.6612 61.4112C45.6956 64.1123 44.5485 66.2562 43.3669 67.6544C42.1853 69.0526 41.0586 69.6547 39.9989 69.6548C38.9393 69.6547 37.8126 69.0526 36.631 67.6544C35.4493 66.2562 34.3023 64.1123 33.3367 61.4112C32.8296 59.9926 32.3747 58.4064 31.9737 56.7094C34.5518 55.8429 37.2193 54.8025 39.9884 53.5027Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('home6') }}</div>
                                <div class="card-text">{{ $t('home7') }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <section id="top-collections">
            <div class="container1366 padding120 padding80">
                <h2 class="home-title">{{ $t('lp-collections09') }}<span>{{ $t('lp-collections11') }}</span></h2>
                <div class="home-subtitle">{{ $t('lp-collections26') }}</div>
                <HomeTopCollectionsCarousel class="home-collections-container" :collections-list="topCollectionItems"></HomeTopCollectionsCarousel>
            </div>
        </section>

        <section id="more-collections">
            <div class="container1366 padding120 padding80 more-collections-container">
                <h2 class="home-title">{{ $t('lp-collections10') }}<span>{{ $t('lp-collections11') }}</span></h2>
                <div class="home-subtitle">{{ $t('lp-collections27') }}</div>
                <HomeMoreCollections class="home-more-collections" :useSlider="false" :collections-list="restCollectionsItems"></HomeMoreCollections>
            </div>
        </section>
        <section class="collection-map">
            <div class="container1366 padding120 padding80 collection-map-container">
                <div class="collection-map-item collection-map-item1">
                    <div class="collection-map-item-title">{{ $t('lp-collections22') }} <div>{{ $t('lp-collections23') }}</div></div>
                    <div class="collection-map-item-mobile"></div>
                    <div class="collection-map-item-text">{{ $t('lp-collections24') }}</div>
                    <nuxt-link :to="localePath('/register')" class="collection-map-item-btn ga4-reg-btn">{{ $t('lp-collections25') }}</nuxt-link>
                </div>
                <div class="collection-map-item collection-map-item2"></div>
            </div>
        </section>
    </main>
</template>

<script>
import { mapGetters } from "vuex";
import HomeMoreCollections from "../components/home/HomeMoreCollections";
import HomeTopCollectionsCarousel from "@/components/home/HomeTopCollectionsCarousel";
import {GOrders} from "@/store/getters";
import {AOrders} from "@/store/actions";
import {GCommon} from "@/store/getters";

export default {
    name: 'LPWineCollectionsInvestor2',
    head: {
        title: 'Fine Wine Collections for Investors | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'collections-page-investors'
        }
    },
    components: {
        HomeMoreCollections, HomeTopCollectionsCarousel
    },
    data(){
        return {
            collectionItems: [],
            topCollectionItems: [],
            restCollectionsItems: []
        }
    },
    computed: {
        ...mapGetters({
            collectionsList: GOrders.GET_COLLECTIONS,
            topCollectionsList: GOrders.GET_TOP_COLLECTIONS,
            collectionsListLength: GOrders.GET_COLLECTIONS_LENGTH,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        }),
        topCollectionIds() {
            let _list = [];
            this.topCollectionsList.forEach(el => {
                _list.push(el.collectionId)
            });
            return _list
        }
    },
    methods: {
        getCollectionItems() {
            this.$store.dispatch(AOrders.GET_TOP_COLLECTIONS, this.$i18n.locale).then(() => {
                this.collectionItems = [];

                this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                    this.collectionItems = this.collectionsList;
                    this.topCollectionItems = [];
                    this.restCollectionsItems = [];

                    let homeCtrl = this;

                    this.collectionItems.forEach(item => {
                        if (homeCtrl.topCollectionIds.indexOf(item.id) > -1) {
                            homeCtrl.topCollectionItems.push(item)
                        }
                        if (homeCtrl.topCollectionIds.indexOf(item.id) < 0) {
                            homeCtrl.restCollectionsItems.push(item)
                        }
                    })
                });
            })
        }
    },
    mounted() {
        this.getCollectionItems();

        this.$nuxt.$on('langUpdated', () => {
            this.getCollectionItems();
        })
    }
};
</script>

<style scoped>
.card-icon {
    height: 80px;
    width: 80px;
    margin: 0 auto 8px;
}
.card-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    margin-bottom: 8px;
    color: #004F7F;
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.card-text {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    font-weight: 400;
    color: #002840;
    font-size: 16px;
    font-style: normal;
    line-height: normal;
}

.container {
    position: relative;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.padding120 {
    padding: 0 120px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}

.slogan {
    height: 792px;
    position: relative;
    background: linear-gradient(90deg, #00304D 21.74%, rgba(0, 48, 77, 0.00) 67.46%), url('../assets/landing/investor/hero-investor.png') no-repeat center;
    background-size: cover;
    margin-bottom: 197px;
}


/* START Top Collections */
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    margin-bottom: 16px;
    position: relative;
    color: #FFF;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.home-title span {
    color: #8CD0FA;
}
.home-subtitle {
    color: #FFF;
    text-align: center;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 40px;
}
.home-collections-container {
    max-width: 1214px;
    margin: 0 auto;
}

.slogan-bullets {
    position: absolute;
    bottom: -107px;
    left: 0;
    right: 0;
}

/* END Top Collections */

.why-vindome-wrapper {
    margin-top: 40px;
}
.why-vindome-wrapper .row {
    margin: 0;
}
.how-icon {
    padding: 16px;
    border-radius: 16px;
    background: white;
    box-shadow: 0 4px 16px 0 rgba(0, 48, 77, 0.12);
}
.why-vindome-col {
    width: calc((100% - 80px) / 3);
    padding: 0;
}
.why-vindome-col-2 {
    margin: 0 40px;
}

#more-collections {
    background: linear-gradient(180deg, #8E8E8E 0%, #717172 100%), #F5F5F5;
}
#top-collections {
    background: linear-gradient(180deg, #45677B 0%, #00304D 100%);
}
.more-collections-container {
    padding-bottom: 34px;
}
.collection-map-container, .hero-wrapper {
    display: flex;
    gap: 40px;
}
.collection-map-item, .hero-text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
}
.collection-map {
    background: #F2F2F2;
}
.collection-map-item-title {
    color: #3C789D;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
}
.collection-map-item-title div {
    color: #004772;
}
.collection-map-item-text {
    color: #002840;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    opacity: 0.8;
}
.collection-map-item-btn {
    border-radius: 8px;
    background: #004F7F;
    padding: 16px;
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-decoration: none;
}
.collection-map-item2 {
    background: url('../assets/landing/investor/map2.png') no-repeat center;
    background-size: contain;
    height: 324px;
}
.collection-map-item {
    justify-content: center;
}
.hero-text-wrapper {
    padding-top: 132px;
}
html[lang="de"] .hero-text-wrapper,
html[lang="it"] .hero-text-wrapper {
    padding-top: 80px;
}
.hero-title {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
html[lang="de"] .hero-title {
    font-size: 43px;
}
.hero-title div {
    color: #8CD0FA;
}
.hero-text {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.hero-btn {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 16px;
    border-radius: 8px;
    border: 2px solid white;
    background:  rgba(255, 255, 255, 0.16);
    text-decoration: none;
}
.collection-map-item-mobile {
    display: none;
}

@media(width: 1024px) {
    .padding120 {
        padding-left: 80px;
        padding-right: 80px;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        min-width: 455px;
    }
    #top-collections .container1366 {
        padding-left: 0;
        padding-right: 0;
    }
    .collection-map-item2 {
        width: 355px;
        height: 230px;
    }
    .collection-map-item1 {
        min-width: 485px;
    }
    .collection-map-item-title {
        font-size: 28px;
    }
}

@media(width: 768px) {
    .padding120 {
        padding-left: 40px;
        padding-right: 40px;
    }
    .padding80 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    .collection-map-item1 {
        min-width: 327px;
    }
    .hero-title {
        font-size: 32px;
    }
    html[lang="de"] .hero-title {
        font-size: 27px;
    }
    .collection-map-item-title, .home-title {
        font-size: 22px;
    }
    .collection-point-title, .hero-text, .card-title {
        font-size: 18px;
    }
    .home-subtitle {
        font-size: 16px;
    }
    .collection-map-item-text, .card-text {
        font-size: 14px;
    }
    .collection-point-text {
        font-size: 12px;
    }
    .hero-text-wrapper, html[lang="it"] .hero-text-wrapper, html[lang="de"] .hero-text-wrapper {
        padding-top: 28px;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        min-width: 377px;
    }
    .slogan {
        height: 515px;
        margin-bottom: 155px;
    }
    .why-vindome-col {
        width: calc((100% - 48px) / 3);
    }
    .why-vindome-col-2 {
        margin: 0 24px;
    }
    .how-icon {
        height: 228px;
    }
    .card-icon, .card-icon svg {
        height: 56px;
        width: 56px;
    }
    .collection-map-item2 {
        height: 186px;
    }
}

@media(max-width: 767px) {
    .why-vindome-col {
        width: 100%;
    }
    .why-vindome-col-2 {
        margin: 24px 0;
    }
    .why-vindome-col-2 .how-icon,
    .why-vindome-col-3 .how-icon {
        height: 212px;
    }
    html[lang="it"] .why-vindome-col-2 .how-icon,
    html[lang="de"] .why-vindome-col-2 .how-icon {
        height: 235px;
    }
    .padding120 {
        padding-left: 16px;
        padding-right: 16px;
    }
    .padding80 {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .hero-text-wrapper {
        display: none;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        display: flex;
        padding-top: 56px;
    }
    .hero-title {
        font-size: 40px;
    }
    html[lang="de"] .hero-title {
        font-size: 35px;
    }
    .hero-text {
        font-size: 18px;
    }
    .slogan {
        height: auto;
        margin-bottom: 0;
        background: url('../assets/landing/investor/hero-investor.png') no-repeat center;
        background-size: 200% 646px;
        background-position: -67px 0;
    }
    .slogan-bullets {
        position: relative;
        bottom: 0;
        margin-top: 40px;
        margin-bottom: 16px;
    }
    .why-vindome-wrapper .row {
        display: block;
    }
    .collection-map-item2 {
        display: none;
    }
    .collection-map-item-mobile {
        display: block;
        background: url('../assets/landing/investor/map2.png') no-repeat center;
        background-size: contain;
        height: 186px;
        width: 100%;
        margin: 16px 0;
    }
    .collection-map-item-title {
        font-size: 22px;
    }
    .collection-map-item-text {
        font-size: 14px;
    }
    .collection-map-item-btn {
        display: inline-block;
        margin-top: 16px;
    }
    .collection-points-container {
        display: block;
    }
    .collection-point-title {
        font-size: 18px;
    }
    .collection-point-text {
        font-size: 12px;
    }
    .collection-point {
        gap: 8px
    }
    .collection-point2 {
        margin: 24px 0;
    }
    .collection-point3 {
        margin-bottom: 24px;
    }
    .hero-btn {
        display: inline-block;
        margin: 16px 0;
    }
    .home-title {
        font-size: 22px;
        margin-bottom: 8px;
    }
    .home-subtitle {
        font-size: 14px;
        margin-bottom: 16px;
    }
}
</style>
<style>
.collections-page-investors .v-main {
    padding-top: 80px !important;
}
.collections-page-investors #more-collections .investment-horizon-wrapper,
.collections-page-investors #more-collections .collection-item {
    background: white;
}
.collections-page-investors #more-collections .collection-item {
    width: calc((100% - 144px)/3);
    margin-right: 72px;
}
.collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
    margin-right: 0;
}
.collections-page-investors #more-collections .collection-subtitle,
.collections-page-investors #more-collections .collection-price-wrapper {
    padding: 0 8px 8px;
}

@media (width: 1024px) {
    .collections-page-investors #more-collections .collection-item {
        width: calc((100% - 48px)/3);
        margin-right: 24px;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
}
@media (width: 768px) {
    .collections-page-investors #more-collections .collection-item {
        width: calc((100% - 40px)/2);
        margin-right: 40px;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 40px;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(2n+0) {
        margin-right: 0;
    }
}
@media (max-width: 767px) {
    .collections-page-investors .vueperslides__bullets:not(.vueperslides__bullets--outside) {
        display: none;
    }
    .collections-page-investors #more-collections .collection-item {
        width: 100%;
        margin-right: 0;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(2n+0),
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
}
</style>
